app.controller("TwoFactorModalController", [
    "$scope", "$state", "$uibModal", "AuthService", "$uibModalInstance", "toastr",
    function ($scope, $state, $uibModal, AuthService, $uibModalInstance, toastr) {
        $scope.token = "";
        $scope.qrCodeUrl = "";

        AuthService.createTwoFactor().then(function (data) {
            $scope.qrCodeUrl = data.qrCode;
        });

        $scope.enableTwoFactor = function () {
            AuthService.enableTwoFactor({
                token: $scope.token
            }).then(function (data) {
                if (data.status === 'ok') {
                    toastr.success('დიჯიპასი წარმატებით გააქტიურდა');
                    $uibModalInstance.close();
                } else {
                    toastr.error('', 'კოდი არასწორია, გთხოვთ ცადოთ კიდევ ერთხელ');
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
